module.exports = __webpack_public_path__ + "img/icon_lb.3e71c998.svg";